<template>
	<payHeader :bgStatus="bgStatus"></payHeader>
	<div class="user-repwd">
		<div class="container">
			<div class="head">
				<h1>找回密码</h1>
				<ul>
					<li class="step1 active">验证账号</li>
					<li class="step2 active">选择找回方式</li>
					<li class="step3 active">填写验证码</li>
					<li class="step4">重设密码</li>
				</ul>
			</div>
			<el-form>
				<el-form-item>
					<span class="label">密保问题</span>
					<el-input v-model="repwdDatas.question" disabled />
				</el-form-item>
				<el-form-item style="margin-bottom: 40px;">
					<span class="label">密保答案</span>
					<el-input v-model="answer" placeholder="请输入密保答案" autocomplete="off" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" class="submit" @click="submitForm">下一步：重置密码</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
	<payFooter></payFooter>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { checkQuescode } from '@/api/home';
	import { payHeader,payFooter } from 'landui-ui';
	import { ElMessage,ElMessageBox } from 'element-plus';
	
	const router = useRouter();
	const bgStatus = ref(true);
	const answer = ref('');
	const repwdDatas = ref({});

	const submitForm = () => {
		const param = {'code':answer.value,'account':repwdDatas.value.account};
		checkQuescode(param).then((res) => {
			if(res.code === 200){
				router.push({ path: '/repwdReset' })
			}
			if(res.code === 205){
				ElMessageBox.confirm(
				    '您在当前页面停留时间过长，请返回第一步',
				    '温馨提示',
				    {
				      confirmButtonText: '立即登录',
				      showCancelButton: false,
				      closeOnClickModal: false,
				      showClose:false,
				      type: 'success',
				    }
				)
				.then(() => {
					router.push({ path: '/repwd' })
				})
				.catch(() => {
					
				})
			}
		})
	};
	
	onMounted(() => {
		repwdDatas.value = JSON.parse(localStorage.getItem('repwdData'));
	})
	
</script>

